/**
 * The types of searches that may be saved through this service
 */
// Similar listings SET_MILES away from that listing (listing/building view top & msg modal)
export const NEARBY_SEARCH = 'nearby'
// Similar listings in that listing's hood (listing/building view neighborhood box)
export const HOOD_SEARCH = 'hood'

export const DEFAULT_ALERT_FREQUENCY = 1440

export const SET_MILES = 6

export const API_RESPONSE = {
  // api error response
  CSRF_NOT_SET: 'CSRF cookie not set.',
  MAXIMUM_SEARCHES: 'max number of searches reached',
  INVALID_EMAIL: 'invalid email',
  OTHER_USER: 'may not create searches with email of other user',
  TOKEN_CONSUMED: 'consumed',
}
export const YOU_NEED_TO_SIGN_IN = 'You need to sign in to manage your alerts.'
export const YOU_DONT_HAVE_ANY_SAVED_SEARCHES = "You don't have any alerts"

export const ALL_SAVED_SEARCHES_ID = 'all'
export const ALL_NEW_SAVED_SEARCHES_ID = 'new'

export const RESET_SAVED_SEARCHES_VIEW = '@@nzr/savedSearchesView/RESET_SAVED_SEARCHES_VIEW'

// SavedSearches
export const GET_SAVED_SEARCHES_REQUEST = '@@nzr/savedSearchesView/GET_SAVED_SEARCHES_REQUEST'
export const GET_SAVED_SEARCHES_SUCCESS = '@@nzr/savedSearchesView/GET_SAVED_SEARCHES_SUCCESS'
export const GET_SAVED_SEARCHES_ERROR = '@@nzr/savedSearchesView/GET_SAVED_SEARCHES_ERROR'
export const UPDATE_SAVED_SEARCHES = '@@nzr/savedSearchesView/UPDATE_SAVED_SEARCHES'

// Removing
export const BEGIN_REMOVING_SAVED_SEARCH = '@@nzr/savedSearchesView/BEGIN_REMOVING_SAVED_SEARCH'
export const ERROR_REMOVING_SAVED_SEARCH = '@@nzr/savedSearchesView/ERROR_REMOVING_SAVED_SEARCH'
export const SUCCESS_REMOVING = '@@nzr/savedSearchesView/SUCCESS_REMOVING'

// Updating
export const SUCCESS_UPDATING = '@@nzr/savedSearchesView/SUCCESS_UPDATING'

// count
export const GET_ALL_COUNT_SUCCESS = '@@nzr/savedSearchesView/GET_ALL_COUNT_SUCCESS'
export const GET_COUNT_SUCCESS = '@@nzr/savedSearchesView/GET_COUNT_SUCCESS'

// clusters
export const RESET_CLUSTERS = '@@nzr/savedSearchesView/RESET_CLUSTERS'

// listables
export const GET_LISTABLES_ERROR = '@@nzr/savedSearchesView/GET_LISTABLES_ERROR'
export const GET_LISTABLES_REQUEST = '@@nzr/savedSearchesView/GET_LISTABLES_REQUEST'
export const GET_LISTABLES_SUCCESS = '@@nzr/savedSearchesView/GET_LISTABLES_SUCCESS'
export const INCREMENT_LOAD_MORE_COUNT = '@@nzr/savedSearchesView/INCREMENT_LOAD_MORE_COUNT'
export const RESET_LISTABLES = '@@nzr/savedSearchesView/RESET_LISTABLES'
export const SET_LISTABLES_LIMIT = '@@nzr/savedSearchesView/SET_LISTABLES_LIMIT'
export const SET_LISTABLES_OFFSET = '@@nzr/savedSearchesView/SET_LISTABLES_OFFSET'

// Filters
export const SET_ALL_FILTERS = '@@nzr/savedSearchesView/SET_ALL_FILTERS,'
export const SET_ONLY_NEW_FILTERS = '@@nzr/savedSearchesView/SET_ONLY_NEW_FILTERS,'

// View
export const HIDE = '@@nzr/savedSearchesView/HIDE'
export const HIDE_SUMMARY = '@@nzr/savedSearchesView/HIDE_SUMMARY'
export const SET_HOVERED = '@@nzr/savedSearchesView/SET_HOVERED'
export const SET_IMAGES = '@@nzr/savedSearchesView/SET_IMAGES'
export const SHOW = '@@nzr/savedSearchesView/SHOW'
export const SHOW_SUMMARY = '@@nzr/savedSearchesView/SHOW_SUMMARY'

// Select
export const DESELECT_SAVED_SEARCH = '@@nzr/savedSearchesView/DESELECT_SAVED_SEARCH'
export const RESET_SELECTED_SAVED_SEARCH = '@@nzr/savedSearchesView/RESET_SELECTED_SAVED_SEARCH'
export const SELECT_ALL = '@@nzr/savedSearchesView/SELECT_ALL'
export const SELECT_ONLY_NEW = '@@nzr/savedSearchesView/SELECT_ONLY_NEW'
export const SELECT_SAVED_SEARCH = '@@nzr/savedSearchesView/SELECT_SAVED_SEARCH'

// misc
export const CLEAR_SUCCESS = '@@nzr/savedSearchesView/CLEAR_SUCCESS'
export const NOT_READY = '@@nzr/savedSearchesView/NOT_READY'
export const READY = '@@nzr/savedSearchesView/READY'
export const SET_ANALYTIC_CHANNEL = '@@nzr/savedSearchesView/SET_ANALYTIC_CHANNEL'
export const SET_ORIGIN = '@@nzr/savedSearchesView/SET_ORIGIN'
